// @flow

import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Link } from '@material-ui/core/';
import Routes from '../../routes';
import './style.css';

type Props = {
    ActiveMenu: string
};

function AppMenu(props: Props) {
    const { ActiveMenu } = props;
    return (
        <Typography component="div" className="app-menu">
            <Link
                color="inherit"
                href={`/${Routes.ApiProducts}`}
                className={ActiveMenu === Routes.ApiProducts ? 'active' : ''}
            >
                API Products
            </Link>
            <Link
                color="inherit"
                href={`/${Routes.Docs}`}
                className={ActiveMenu === Routes.Docs ? 'active' : ''}
            >
                Docs
            </Link>
            <Link
                color="inherit"
                href={`/${Routes.Api}`}
                className={ActiveMenu === Routes.Api ? 'active' : ''}
            >
                Get Started
            </Link>
            <Link
                color="inherit"
                href={`/${Routes.Download}`}
                className={ActiveMenu === Routes.Download ? 'active' : ''}
            >
                Download
            </Link>
            <Link
                color="inherit"
                href={`/${Routes.Support}`}
                className={ActiveMenu === Routes.Support ? 'active' : ''}
            >
                Support
            </Link>
        </Typography>
    );
}

AppMenu.propTypes = {
    ActiveMenu: PropTypes.string.isRequired
};

export default AppMenu;
